// extracted by mini-css-extract-plugin
export default {"calenderEvents":"calenderEvents_calenderEvents__DGVve","mainSection":"calenderEvents_mainSection__N0NIX"};